import crud from './crud'

export default {
    namespaced: true,
    state: {
        ...crud.state,
    },
    mutations: {
        ...crud.mutations,
    },
    actions: {
        ...crud.actions,
    }
}